import { date } from '@/filters/date';

// @vuese
// Mixin podpisów
export const signatureMixin = {
  methods: {
    // @vuese
    // Informacja o podpisie
    signature(attachment) {
      if (!attachment || !attachment.metadata || !attachment.metadata.signature) {
        return 'Nie';
      }
      const signedBy = `Dokument podpisany przez: ${attachment.metadata.signature.signedBy}, `;
      const validSince = `certyfikat ważny od ${date(attachment.metadata.signature.validity.notBefore)}`;
      if (!attachment.metadata.signature.validity.notAfter) {
        return signedBy + validSince;
      }
      const validUntil = ` do ${date(attachment.metadata.signature.validity.notAfter)}`;
      return signedBy + validSince + validUntil;
    }
  }
};
